// extracted by mini-css-extract-plugin
export var dataCell = "_qm-2";
export var dataRow = "_qm-0";
export var headerRow = "_qm-1";